<script setup lang="ts">
import {ref, computed} from "vue";
import { useI18n } from 'vue-i18n'

import {useAppStore} from "@/store/app";
import {useUserStore} from "@/store/user";

const appStore = useAppStore()
const userStore = useUserStore()
const { t } = useI18n()

const selected = ref("")

const baseNavs = computed(() => [
  { name: t('nav.home'), icon: 'mdi-home-outline', selected: 'mdi-home', path: '/' },
  { name: t('nav.servers'), icon: 'mdi-dns-outline', selected: 'mdi-dns', path: '/server' },
  { name: t('nav.member'), icon: 'mdi-crown-outline', selected: 'mdi-crown', path: '/member' },
  { name: t('nav.modules'), icon: 'mdi-puzzle-outline', selected: 'mdi-puzzle', path: '/module' },
  { name: t('nav.developer'), icon: 'mdi-file-code-outline', selected: 'mdi-file-code', path: '/developer' },
])

const navs = computed(() => {
  if (userStore.isAdmin) {
    return [
      ...baseNavs.value,
      { name: t('nav.admin'), icon: 'mdi-shield-crown-outline', selected: 'mdi-shield-crown', path: '/admin' },
    ]
  }
  return baseNavs.value
})
</script>

<template>
  <v-bottom-navigation :active="appStore.getNav && $vuetify.display.mobile" v-model="selected" mandatory fixed height="80">
    <v-btn size="x-small" :to="nav.path" v-for="nav in navs" :key="nav.name" :value="nav.name" class="nav-btn ml-1 mr-1" :ripple="false">
      <v-icon size="24">{{ selected === nav.name ? nav.selected : nav.icon }}</v-icon>
      <span :class="selected === nav.name ? 'font-weight-bold' : ''">{{ nav.name }}</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<style scoped>

</style>
